import React from 'react';
import PricingPage from './pages/PricingPage';
import '@questlabs/react-sdk/dist/style.css';

function App() {
  return (
    <div className="app-container">
      <PricingPage />
    </div>
  );
}

export default App;